export function renderIcon(kindengezinPath, iconName, iconClasses) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');

    svg.classList.add(...iconClasses);
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    use.setAttributeNS(
        'http://www.w3.org/1999/xlink',
        'xlink:href',
        `/${kindengezinPath}/dist/icons/symbol-defs.svg#icon-${iconName}`,
    );
    svg.appendChild(use);

    return svg;
}
